import { HStack, Tooltip } from '@/components/sgBootstrapReactWrapper';
import { getOtherServicesURL } from '@/config/config';
import { useAppSelector } from '@/store/hooks';
import { getSelectedEntity } from '@/store/user/userSlice';
import { FormattedMessage } from 'react-intl';

export const AsmButton = () => {
  const selectedEntity = useAppSelector(getSelectedEntity);
  const asmTooltip = <FormattedMessage id="openAsmWeb.tooltip" />
  const asmUrl = getOtherServicesURL(selectedEntity, 'asm');

  return (
    <Tooltip contents={asmTooltip}>
      <a
        className="btn btn-default btn-md  ms-12px p-12px ps-24px"
        href={asmUrl}
        target="avaloq_search_open_by_cockpit"
        data-e2e="link-to-advanced-search">
        <HStack gap="12px">
          <FormattedMessage id="openAsmWeb" />
          <em className="icon">open_in_new</em>
        </HStack>
      </a>
    </Tooltip>
  );
};